import * as React from "react";
import BaseLayout from "../../components/BaseLayout";
import EditGroup from "../../features/EditGroup";

function EditGroupPage() {
  return (
    <BaseLayout>
      <EditGroup />
    </BaseLayout>
  );
}

export default EditGroupPage;
